// GDPRLocal navigation and footer, mirrored exactly from the live gdprlocal.com header and footer.
const SITE = "https://gdprlocal.com";
export const PORTAL_LOGIN = "https://portal.gdprlocal.com/Account/Login";
export const PORTAL_REGISTER = "https://portal.gdprlocal.com/Account/Register";
export const CONTACT = `${SITE}/contact/`;
export const PRICING = `${SITE}/pricing/`;
export const LOGO = "https://gdprlocal.com/wp-content/uploads/2024/10/logo_header.png";

// Header: Services dropdown (exact live order and labels)
export const SERVICES = [
    { label: "GDPR Data Protection Officer Service", href: `${SITE}/gdpr-data-protection-officer/` },
    { label: "GDPR Article 27 EU Representative", href: `${SITE}/gdpr-article-27-eu-representative/` },
    { label: "AI and Data Protection Training Services", href: `${SITE}/ai-and-data-protection-compliance-training/` },
    { label: "Singapore DPO", href: `${SITE}/singapore-dpo/` },
    { label: "GDPR Article 27 UK Representative", href: `${SITE}/gdpr-article-27-uk-representative/` },
    { label: "EU AI Act Article 22 Representative", href: `${SITE}/ai-representative/` },
    { label: "GDPR Consultancy Services", href: `${SITE}/gdpr-consultant/` },
    { label: "FADP Article 14 Swiss Representative", href: `${SITE}/fadp-article-14-swiss-representative/` },
    { label: "AI Governance Services", href: `${SITE}/ai-governance/` },
    { label: "GDPR Project Delivery Services", href: `${SITE}/compliance-projects/` },
];

export const SOLUTIONS_GROUP = "By company size";
export const SOLUTIONS = [
    { label: "Start-ups and fast movers", href: `${SITE}/solutions/start-ups-and-fast-movers/` },
    { label: "SME and hyper growth", href: `${SITE}/solutions/sme-and-hyper-growth/` },
    { label: "Corporates and enterprise", href: `${SITE}/solutions/corporates-and-enterprise/` },
    { label: "By approach", href: `${SITE}/solutions/by-approach/` },
];

export const FRAMEWORKS = [
    { label: "Data Protection", href: `${SITE}/frameworks/data-protection/` },
    { label: "Info Sec SOC2 / ISO27001", href: `${SITE}/frameworks/info-sec-soc2-iso27001/` },
    { label: "AI Act", href: `${SITE}/frameworks/info-sec-soc2-iso27001/#aiact` },
];

export const ABOUT = [
    { label: "About us", href: `${SITE}/about-us/` },
    { label: "Contact", href: `${SITE}/contact/` },
];

export const RESOURCES = [
    { label: "Blog", href: `${SITE}/blog/` },
    { label: "Data Protection Glossary", href: `${SITE}/data-protection-glossary/` },
    { label: "GDPR Enforcement Tracker", href: `${SITE}/gdpr-enforcement-tracker/` },
    { label: "FAQ", href: `${SITE}/faq/` },
    { label: "Partners", href: `${SITE}/partners/` },
];

// Footer: Services (exact live footer order)
export const FOOTER_SERVICES = [
    { label: "GDPR Article 27 EU Representative", href: `${SITE}/gdpr-article-27-eu-representative/` },
    { label: "GDPR Article 27 UK Representative", href: `${SITE}/gdpr-article-27-uk-representative/` },
    { label: "FADP Article 14 Swiss Representative", href: `${SITE}/fadp-article-14-swiss-representative/` },
    { label: "GDPR Project Delivery Services", href: `${SITE}/compliance-projects/` },
    { label: "Singapore DPO", href: `${SITE}/singapore-dpo/` },
    { label: "GDPR Data Protection Officer Service", href: `${SITE}/gdpr-data-protection-officer/` },
    { label: "GDPR Consultancy Services", href: `${SITE}/gdpr-consultant/` },
    { label: "AI Governance Services", href: `${SITE}/ai-governance/` },
    { label: "AI and Data Protection Training Services", href: `${SITE}/ai-and-data-protection-compliance-training/` },
    { label: "EU AI Act Article 22 Representative", href: `${SITE}/ai-representative/` },
];

export const FOOTER_SOLUTIONS = [
    { label: "Start up and Fast Movers", href: `${SITE}/solutions/start-ups-and-fast-movers/` },
    { label: "SME and Hyper Growth", href: `${SITE}/solutions/sme-and-hyper-growth/` },
    { label: "Corporates and Enterprise", href: `${SITE}/solutions/corporates-and-enterprise/` },
    { label: "By approach", href: `${SITE}/solutions/by-approach/` },
];

export const FOOTER_ABOUT = [
    { label: "About us", href: `${SITE}/about-us/` },
    { label: "Contact", href: `${SITE}/contact/` },
    { label: "Partners", href: `${SITE}/partners/` },
    { label: "Affiliate", href: `${SITE}/affiliate/` },
];

export const LEGAL = [
    { label: "Cookie Policy", href: `${SITE}/cookie-policy/` },
    { label: "Privacy Policy", href: `${SITE}/privacy-statement/` },
    { label: "DPA/SCC/ADDENDUM", href: `${SITE}/dpa-scc-addendum/` },
    { label: "NDA", href: `${SITE}/nda/` },
    { label: "Terms & Conditions", href: `${SITE}/terms-of-use/` },
];

export const FOOTER_CTA = {
    heading: "AI Regulation is here - GDPRLocal can help",
    subtext: "Need help with an AI risk assessment? Looking for advice on governance? Need a complete set of compliance documentation? Our experienced data protection and AI consultants can help.",
};
